import React, {Component} from "react";
import Loader from "../loader";

class Analyze extends Component {
    constructor() {
        super();
    }

    renderHint() {
        const {data} = this.props;
        return (
            <div className="hint-container">
                <div className="hint-icon">
                    <img src={process.env.PUBLIC_URL + '/hint.png'} alt="hint"/>
                </div>
                Hey, for the better match, please mention these tags:&nbsp; 
                {data.resumeData.practice_area && data.resumeData.practice_area.length > 0 ? null :
                    <div className="list"><span>Practice Area</span><span>, </span></div>}
                {data.resumeData.skills && data.resumeData.skills.length > 0 ? null :
                    <div className="list"><span>Skills</span><span>, </span></div>}
                {data.resumeData.qualification && data.resumeData.qualification.length > 0 ? null :
                <div className="list"><span>Qualification</span><span>, </span></div>}
                {data.resumeData.qualification_specialization && data.resumeData.qualification_specialization.length > 0 ? null :
                    <div className="list"><span>Qualification Specialization</span><span>, </span></div>}             
                {data.resumeData.experience && data.resumeData.experience.length > 0 ? null :
                    <div className="list"><span>Experience</span><span>, </span></div>}
                {data.resumeData.business_segment && data.resumeData.business_segment.length > 0 ? null :
                    <div className="list"><span>Business Segment</span><span>, </span></div>}
                {data.resumeData.certification && data.resumeData.certification.length > 0 ? null :
                    <div className="list"><span>Certification</span><span>, </span></div>}
                {data.resumeData.location && data.resumeData.location.length > 0 ? null :
                    <div className="list"><span>Location</span><span>, </span></div>}.
            </div>
        )
    }

    renderTagData(item) {
        return(
            <div className="list-alternate">
                {item.practiceArea && item.practiceArea.length > 0 ?
                    <div className="list">
                        <b>Practice Area</b>: {item.practiceArea.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.skills && item.skills.length > 0 ?
                    <div className="list">
                        <b>Skills</b>: {item.skills.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.qualification && item.qualification.length > 0 ?
                    <div className="list">
                        <b>Qualification</b>: {item.qualification.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.qualificationSpecialization && item.qualificationSpecialization.length > 0 ?
                    <div className="list">
                        <b>Qualification Specialization</b>: {item.qualificationSpecialization.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.experience && item.experience.length > 0 ?
                    <div className="list">
                        <b>Experience</b>: {item.experience.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.businessSegment && item.businessSegment.length > 0 ?
                    <div className="list">
                        <b>Business Segment</b>: {item.businessSegment.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.industry && item.industry.length > 0 ?
                    <div className="list">
                        <b>Industry</b>: {item.industry.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.certification && item.certification.length > 0 ?
                    <div className="list">
                        <b>Certification</b>: {item.certification.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.location && item.location.length > 0 ?
                    <div className="list">
                        <b>Location</b>: {item.location.map((item,index) => <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
            </div>
        )
    }

    renderTableData() {
        return this.props.data.resumeData.entries.map((resume, index) => {
            const {matches, nonMatches, percentage, resumePath} = resume
            return (
                <tr>
                    <td>
                        <div className="bar-container">
                            <div className="bar">
                                <div className="bar-fill" style={{width: `${percentage}%`}} />
                                <div className="bar-percentage">
                                    {percentage + "%"}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        {this.renderTagData(matches)}
                    </td>
                    <td>
                        {this.renderTagData(nonMatches)}
                    </td>
                    <td>
                        <a href={resumePath} target="_blank" className="btn">View Resume</a>
                    </td>
                </tr>
            )
        })
    }

    render() {
        const {data, loading} = this.props;
        const messageOne = 'Please Wait...';
        const messageTwo = 'Fetching Matches';
        if (loading) {
            return <Loader messageOne={messageOne} messageTwo={messageTwo}/>
        }
        return (
            <div className="analyze-container">
                <div className="tag-container">
                    <div className="tag matches">
                        <div className="tags-heading"><b>Total resumes matched:</b></div>
                        <div className="tag-count-container">
                            <div
                                className="tag-count">{data.resumeData.matches_resume}/{data.resumeData.total_resumes}</div>
                        </div>
                    </div>
                    <div className="tag list-item">
                        <div className="tags-heading"><b>Tags:</b></div>
                        <ul className="tags-list">
                            <li>Practice Area: {data.resumeData.practice_area.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Skills: {data.resumeData.skills.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Qualification: {data.resumeData.qualification.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Qualification
                                Specialization: {data.resumeData.qualification_specialization.map((item, index) =>
                                    <div className="list">
                                        <span>{item}</span>
                                        <span>, </span>
                                    </div>
                                )}</li>
                            <li>Experience: {data.resumeData.experience.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Business Segment: {data.resumeData.business_segment.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Industry: {data.resumeData.industry.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Certification: {data.resumeData.certification.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                            <li>Location: {data.resumeData.location.map((item, index) =>
                                <div className="list">
                                    <span>{item}</span>
                                    <span>, </span>
                                </div>
                            )}</li>
                        </ul>
                    </div>
                </div>
                {this.renderHint()}
                <div className="analyze-container-title">
                    <b>Resumes</b>
                </div>
                <table className="data-table">
                    <tr className="header">
                        <th><b>Percentage</b></th>
                        <th><b>Matched</b></th>
                        <th><b>Did Not Match</b></th>
                        <th><b>Resumes</b></th>
                    </tr>
                    {this.renderTableData()}
                </table>
            </div>
        )
    }
}

export default Analyze;
